import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutGrid1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-grid-1, grid, window"><path d="M3.75 3.75H10.25V8.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M13.75 15.75H20.25V20.25H13.75V15.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M3.75 11.75H10.25V20.25H3.75V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M13.75 3.75H20.25V12.25H13.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconLayoutGrid1;
